import React from "react";
import { Routes, Route } from "react-router-dom";
import Main from "../Pages/Main";
import Product from "../Pages/Product";
import AllProducts from "../Pages/AllProducts";
import Header from "../components/Header";
import Footer from "../components/Footer";
import NotFound from "../Pages/NotFound";
import SingleCategory from "../Pages/SingleCategory";
import Cart from "../Pages/Cart";
import Checkout from "../Pages/Checkout";
import AboutUs from "../Pages/AboutUs";

const MainLayout = () => {
  return (
    <>
      <Header />
      <Routes>
        <Route path="" element={<Main />} />
        <Route path="/products" element={<AllProducts />} />
        <Route path="/product/view/:product_id" element={<Product />} />
        <Route path="/products/category/:name" element={<SingleCategory />} />
        <Route path="/cart" element={<Cart />} />
        <Route path="/checkout" element={<Checkout />} />
        <Route path="/about" element={<AboutUs />} />

        <Route path="*" element={<NotFound />} />
      </Routes>
      <Footer />
    </>
  );
};

export default MainLayout;
